import { closeCart } from 'state/actions/ajax-cart';
import ACTIONS from 'state/constants';

export const setTopNavigationData = data => dispatch => {
  dispatch({ type: ACTIONS.SET_TOP_NAVIGATION_DATA, payload: { data } });
};

export const setCurrentTopNavigationNode = id => dispatch => {
  dispatch({ type: ACTIONS.SET_CURRENT_TOP_NAVIGATION_NODE, payload: { id } });
};

export const toggleTopNavigation = () => dispatch => {
  dispatch({ type: ACTIONS.TOGGLE_MOBILE_TOP_NAVIGATION, payload: {} });
  dispatch(closeCart());
};

export const closeTopNavigation = () => dispatch => {
  dispatch({ type: ACTIONS.CLOSE_TOP_NAVIGATION, payload: {} });
};

export const closeSearchQuickResults = () => dispatch => {
  dispatch({ type: ACTIONS.CLOSE_SEARCH_QUICK_RESULTS, payload: {} });
};

export const openSearchQuickResults = () => dispatch => {
  dispatch({ type: ACTIONS.OPEN_SEARCH_QUICK_RESULTS, payload: {} });
};

export const trackGlobalBannerClick =
  ({ message }) =>
  dispatch => {
    dispatch({ type: ACTIONS.TRACK_BANNER_CLICK, payload: { message } });
  };
